import React from 'react'
import { SubmissionDetails } from './SubmissionDetails'

const FormTable = () => {
  return (
    <>
      <SubmissionDetails />
    </>
  )
}

export default FormTable
